;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockFoodServiceContactForm from './BlockFoodServiceContactForm';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockFoodServiceContactForm(preview: $preview, id: $id) {
            __typename
            card {
                ... on CardTillamaps {
                    headline
                    copy
                    cta {
                        ... on Cta {
                            ...CTA
                        }
                    }
                    icon {
                        ... on Icon {
                            ...Icon
                        }
                    }
                }
            }
            flushTop
            flushBottom
            formId
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockFoodServiceContactForm },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockFoodServiceContactForm;
}

const BlockFoodServiceContactFormServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockFoodServiceContactForm {...block} />;
};

export default BlockFoodServiceContactFormServer;
